import { useEffect, useState } from "react";
import { Smartphone, Download, Ticket, Building2, BarChart3, Printer, Wallet } from "lucide-react";

const APKS = [
  { file: "gprtu-intercity.apk", label: "Customer", desc: "Book & manage trips", icon: Smartphone, tint: "bg-blue-50 text-[#0052FF]" },
  { file: "gprtu-teller.apk", label: "Teller", desc: "Counter sales & scan", icon: Ticket, tint: "bg-emerald-50 text-emerald-600" },
  { file: "gprtu-teller-pos.apk", label: "Teller POS", desc: "Thermal-printer terminal", icon: Printer, tint: "bg-teal-50 text-teal-600" },
  { file: "gprtu-station.apk", label: "Station Master", desc: "Departures & sign-out", icon: Building2, tint: "bg-orange-50 text-orange-600" },
  { file: "gprtu-station-pos.apk", label: "Station POS", desc: "Station printer terminal", icon: Printer, tint: "bg-amber-50 text-amber-700" },
  { file: "gprtu-accounts.apk", label: "Accounts", desc: "Cashier & cash office", icon: Wallet, tint: "bg-violet-50 text-violet-600" },
  { file: "gprtu-management.apk", label: "Management", desc: "Financial dashboard", icon: BarChart3, tint: "bg-indigo-50 text-indigo-600" },
];

const fmtWhen = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

export default function AppDownloads() {
  const [meta, setMeta] = useState({});
  useEffect(() => {
    fetch("/downloads/apps.json")
      .then((r) => (r.ok ? r.json() : {}))
      .then(setMeta)
      .catch(() => setMeta({}));
  }, []);

  const avail = APKS.filter((a) => meta[a.file]);
  if (!avail.length) return null;

  return (
    <div className="mt-12" data-testid="app-downloads">
      <div className="mb-4 flex flex-col items-center text-center">
        <div className="label-xs">Android apps</div>
        <h2 className="font-display text-2xl font-extrabold tracking-tight text-[#182678]">Download the GPRTU apps</h2>
        <p className="mt-1 max-w-xl text-sm text-slate-500">Install the latest signed Android apps for each role. Open the file on your device to install.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {avail.map((a) => {
          const Icon = a.icon;
          const m = meta[a.file] || {};
          return (
            <a
              key={a.file}
              href={`/downloads/${a.file}`}
              download
              data-testid={`apk-download-${a.file}`}
              className="card-soft group flex items-center gap-3 p-4 text-left transition-all hover:-translate-y-0.5 hover:shadow-lg"
            >
              <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${a.tint}`}><Icon className="h-5 w-5" /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-display text-base font-extrabold text-[#182678]">{a.label}</span>
                <span className="block truncate text-xs text-slate-500">{a.desc}</span>
                <span className="mt-0.5 block text-[11px] text-slate-400" data-testid={`apk-meta-${a.file}`}>
                  {m.published_at ? `Published ${fmtWhen(m.published_at)}` : ""}{m.size_mb ? ` · ${m.size_mb} MB` : ""}
                </span>
              </span>
              <Download className="h-5 w-5 shrink-0 text-slate-300 transition-colors group-hover:text-[#0052FF]" />
            </a>
          );
        })}
      </div>
    </div>
  );
}
